const Tracim = () => {
  return <iframe style={{ width: "100vw", height: "100vh" }} src="https://mon.tracim.fr/" />;
};

export default Tracim;
